module.exports = __webpack_public_path__ + "img/imgBox_bg.f197a16b.png";